// 调官网cms接口

import axios from './http';
import base from './base';


// 获取新闻分类列表
export function getNewsCategoryList(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/newsCategory/getNewsCategoryList`,
    method: 'get',
    headers: {
      notLoading: true
    },
    params
  });
}

// 分页获取新闻列表
export function getNewsListByPage(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/news/getNewsListByPage`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: params
  });
}

// 根据新闻id获取新闻内容
export function getNewsContentById(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/news/getNewsContentById`,
    method: 'get',
    headers: {
      notLoading: true
    },
    params
  });
}

// 获取精选新闻列表
export function getFineNewsList(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/news/getFineNewsList`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: params
  });
}

// 获取首页新闻列表
export function getIndexNewsList(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/news/getIndexNewsList`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: params
  });
}

// 根据新闻id获取上一篇和下一篇新闻
export function getPrevious2NextNewsById(params) {
  return axios({
    url: `${base.cmsUrl}/jishuiyun-portal/news/getPrevious2NextNewsById`,
    method: 'post',
    headers: {
      notLoading: true
    },
    data: params
  });
}
